// src/processors/resource/resource-validator.ts - Resource Validation Operations
import { XConVitePluginOptions } from '../../types';
import {Logger} from "../../utils/logger";

/**
 * Handles validation of resource objects and configurations
 */
export class ResourceValidator {
    constructor(
        private options: Required<XConVitePluginOptions>,
        private logger: Logger
    ) {}

    /**
     * Validate resource object
     */
    isValidResource(resource: any): boolean {
        return resource &&
            typeof resource === 'object' &&
            this.isValidResourceName(resource.name) &&
            this.isValidResourceUrl(resource.url);
    }

    /**
     * Validate resource name
     */
    isValidResourceName(name: any): boolean {
        return typeof name === 'string' && name.length > 0;
    }

    /**
     * Validate resource URL
     */
    isValidResourceUrl(url: any): boolean {
        return typeof url === 'string' && url.length > 0;
    }
}